import { DEFAULT_TEMPLATE } from './default-template';
import { AMOUNT_ORDERNUMBER_TEMPLATE } from './amount-order-number-template';
import { CUSTOMER_NAME_TEMPLATE } from './customer-name-template';
import { CUSTOMER_ADDRESS_TEMPLATE } from './customer-address-template';
export const TEMPLATE_ARR = [DEFAULT_TEMPLATE, AMOUNT_ORDERNUMBER_TEMPLATE, CUSTOMER_NAME_TEMPLATE, CUSTOMER_ADDRESS_TEMPLATE];
